import React from 'react';
import { Link } from 'react-router-dom';
import './AboutPreview.css';
import OptimizedImage from '../OptimizedImage/OptimizedImage';

const AboutPreview: React.FC = () => {
  return (
    <section className="about-preview-wrapper">
      <div className="container">
        <div className="about-preview-content">
          <div className="about-preview-text">
            <div className="title">
              <h1>Innovating <span id="gold">interior spaces</span> with a focus on style.</h1>
            </div>
            <div className="more-about">
              <h3>More About us</h3>
            </div>
            <p>
              We are a <span id="gold">premier</span> architectural firm dedicated to creating 
            innovative, <span id="gold">sustainable</span>, and <span id="gold">beautiful</span> spaces. Our team 
            combines <span id="gold">creative vision</span> with technical expertise to deliver exceptional 
            architectural solutions that exceed our clients' expectations.
            </p>
            <Link to="/about" className="learn-more-btn">
              <div className="btn-icon">
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M5 12h14m-7-7 7 7-7 7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="btn-text">
                <h4>Learn More About Us</h4>
              </div>
            </Link>
          </div>
          <div className="about-preview-image">
            <OptimizedImage
              src="/assets/images/kitchen_m/kitchen_m_1_compressed.png"
              alt="BlueLake Studio"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;